import {
  ScheduleType,
  type BackupSchedule,
  type BackupPolicyConfig,
} from '@repo/api-gw-sdk';
import { v4 as uuid } from 'uuid';

import { MIN_WINDOW_HOURS } from '../controls/hoursSelector';
import {
  dailyFrequency,
  getWindowHoursDuration,
  thirtyMinutesFrequency,
} from '../frequency';

export const getDefaultStandardSchedules = (
  vaultId = '',
  scheduleType: ScheduleType = ScheduleType.SCHEDULE_TYPE_STANDARD
): BackupSchedule[] => [
  {
    id: uuid(),
    duration: MIN_WINDOW_HOURS * 60,
    backupRetention: dailyFrequency.defaultRetentionInDays,
    vaultId,
    windows: dailyFrequency.windows,
    scheduleType,
  },
];

const BIGQUERY_NATIVE_PITR_RETENTION_DAYS = 7;

export const getDefaultBigQueryPitrSchedules = (): BackupSchedule[] =>
  getDefaultStandardSchedules().map((s) => ({
    ...s,
    backupRetention: BIGQUERY_NATIVE_PITR_RETENTION_DAYS,
  }));

export const getDefaultHighFrequencySchedules = (
  vaultId = '',
  scheduleType: ScheduleType = ScheduleType.SCHEDULE_TYPE_STANDARD
): BackupSchedule[] => [
  {
    id: uuid(),
    duration: getWindowHoursDuration(thirtyMinutesFrequency) * 60,
    backupRetention: thirtyMinutesFrequency.defaultRetentionInDays,
    vaultId,
    windows: thirtyMinutesFrequency.windows,
    scheduleType,
  },
];

export const defaultBackupPolicy: BackupPolicyConfig = {
  name: '',
  exclude: [],
  include: [],
  enabled: true,
  schedules: getDefaultStandardSchedules(),
  attachedResources: 0,
  id: '',
};
